module.exports = __webpack_public_path__ + "img/nbc-news.cacd9336.png";